import { z } from 'zod';

export const workspaceTypes = [
  'ledger',
  'payments',
  'free_tier_ledger',
] as const;
export const WorkspaceTypeSchema = z.enum(workspaceTypes);
export type WorkspaceType = (typeof workspaceTypes)[number];

/** Maximum number of members in a `free_tier_ledger` workspace. */
export const FREE_TIER_MAX_MEMBERS = 3;
